import React, { useState } from 'react'
import { Modal, Button, Form, Spinner } from 'react-bootstrap'
import { useActionFetch } from '@/utils/requests'
import { useForm } from 'react-hook-form'
import User from '@/types/User'
import { apiInvitations } from '@/routes'
import { useToaster } from '@/components/shared/ToasterProvider'


interface InviteUserModalProps {
  projectId: number;
  visible: boolean;
  onClose: () => void;
}

export default function InviteUserModal({ projectId, visible, onClose }: InviteUserModalProps) {
  const [loading, setLoading] = useState(false)
  const { register, handleSubmit } = useForm<User>()
  const { actionFetch } = useActionFetch()
  const showToaster = useToaster()

  const onSubmit = async (user: User) => {
    const { email, firstName, lastName } = user
    setLoading(true)

    try {
      const user = await actionFetch<User>(apiInvitations.create(projectId), {
        body: JSON.stringify({
          email,
          first_name: firstName,
          last_name: lastName,
        }),
      })

      showToaster({ message: `Invitation sent successfully to ${user.email}` })
    } finally {
      setLoading(false)
    }
  }

  return (
    <Modal show={visible} onHide={onClose}>
      <Modal.Header closeButton>
        <Modal.Title>Invite User</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form onSubmit={handleSubmit(onSubmit)} className="d-flex flex-column gap-3">
          <Form.Group>
            <Form.Label>First name</Form.Label>
            <Form.Control
              placeholder="Enter user first name"
              disabled={loading}
              {...register('firstName')}
            />
          </Form.Group>
          <Form.Group>
            <Form.Label>Last name</Form.Label>
            <Form.Control
              placeholder="Enter user last name"
              disabled={loading}
              {...register('lastName')}
            />
          </Form.Group>
          <Form.Group>
            <Form.Label>Email address</Form.Label>
            <Form.Control
              type="email"
              placeholder="Enter user email"
              required
              disabled={loading}
              {...register('email')}
            />
          </Form.Group>
          <Button variant="primary" type="submit" disabled={loading} className="mt-3"
                  style={{ width: '100%' }}>
            {loading ? <><Spinner animation="border" size="sm" /> Sending...</> : 'Send Invitation'}
          </Button>
        </Form>
      </Modal.Body>
    </Modal>
  )
};
